//  Establish connection to the wallet
export async function connect() {
    return await (window as any).aptos.connect()
}


// Check connection status of wallet
export async function isConnected() {
    return await (window as any).aptos.isConnected()
}

// Check connection status of wallet
export async function account() {
    return await (window as any).aptos.account()
}


// Disconnect dApp from the wallet
export async function disconnect(transaction: any) {
    return await (window as any).aptos.disconnect(transaction)
}

// Send transaction to the extension to be signed and submitted to chain
export async function signAndSubmitTransaction(transaction: any) {
    return await (window as any).aptos.signAndSubmitTransaction(transaction)
}

// Send transaction to the extension to be signed and returns
export async function signTransaction(transaction: any) {
    return await (window as any).aptos.signAndSubmitTransaction(transaction)
}


export function createTransaction(receiverAddress: string, amount: number) {
    return {
        type: 'script_function_payload',
        function: '0x1::coin::transfer',
        type_arguments: ['0x1::aptos_coin::AptosCoin'],
        arguments: [receiverAddress, amount]
    }
}


